import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './main/App';
import './utils/i18n';

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback="">
      <App />
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

